<template><div><h4 class="d-docsite--header-4">Default Scroller</h4>
<code-well-header>
 <dt-scroller
      style="
      margin: 20px 0;
      border: 1px solid red;"
      :items="[
              {
                id: 1,
                name: `User 1`,
              },
              {
                id: 2,
                name: `User 2`,
              },
              {
                id: 3,
                name: `User 3`,
              },
              {
                id: 4,
                name: `User 4`,
              },
              {
                id: 5,
                name: `User 5`,
              },
              {
                id: 6,
                name: `User 6`,
              },
              {
                id: 7,
                name: `User 7`,
              },
              {
                id: 8,
                name: `User 8`,
              },
              {
                id: 9,
                name: `User 9`,
              },
              {
                id: 10,
                name: `User 10`,
              },
              {
                id: 11,
                name: `User 11`,
              },
              {
                id: 12,
                name: `User 12`,
              },
              {
                id: 13,
                name: `User 13`,
              },
              {
                id: 14,
                name: `User 14`,
              },
              {
                id: 15,
                name: `User 15`,
              }
          ]"
      :item-size="32"
      :scroller-height="200"
      :scroller-width="200"
      list-tag="div"
      item-tag="div"
      direction="vertical"
      >
      <template #default="{ item }">
              <div style="
                height: 25px;
                padding: 0 12px;
                display: flex;
                align-items: center;
                border-bottom: 1px solid #eee;
              ">
                {{ item.name }}
              </div>
      </template>
</dt-scroller>
</code-well-header>
<br>
<div class="language-html" data-highlighter="prismjs" data-ext="html"><pre v-pre><code class="language-html"><span class="line"><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>dt-scroller</span></span>
<span class="line"> <span class="token attr-name">:items</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>items<span class="token punctuation">"</span></span></span>
<span class="line"> <span class="token attr-name">:item-size</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>32<span class="token punctuation">"</span></span></span>
<span class="line"> <span class="token attr-name">:scroller-height</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>200<span class="token punctuation">"</span></span></span>
<span class="line"> <span class="token attr-name">:scroller-width</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>300<span class="token punctuation">"</span></span></span>
<span class="line"> <span class="token punctuation">></span></span></span>
<span class="line"> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>template</span> <span class="token attr-name">#default</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>{ item }<span class="token punctuation">"</span></span><span class="token punctuation">></span></span></span>
<span class="line">   <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>user<span class="token punctuation">"</span></span><span class="token punctuation">></span></span></span>
<span class="line">     {{ item.name }}</span>
<span class="line">   <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span></span>
<span class="line"> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>template</span><span class="token punctuation">></span></span></span>
<span class="line"><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>dt-scroller</span><span class="token punctuation">></span></span></span>
<span class="line"></span></code></pre>
</div><h4 class="d-docsite--header-4">Dynamic Scroller</h4>
<code-well-header>
 <dt-scroller
      :items="[
              {
                id: 1,
                message: 'lorem ipsum dolor sit amet',
              },
              {
                id: 2,
                message: 'lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec auctor, nisl eget ultrices aliquam',
              },
              {
                id: 3,
                message: 'lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec auctor, nisl eget ultrices aliquam, nunc nisl aliquet nunc, eget aliquam nisl',
              },
              {
                id: 4,
                message: 'lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec auctor,nisl eget ultrices aliquam, nunc nisl aliquet nunc, eget aliquam nisl ni loremlorem ipsum dolor sit amet, consectetur adipiscing elit. Donec auctor, nisl eget ultrices aliquam, nunc nisl aliquet nunc, eget aliquam nisl ni loremlorem ipsum dolor sit amet, consectetur adipiscing elit. Donec auctor, nisl eget ultrices aliquam',
              },
              {
                id: 5,
                message: 'lorem ipsum dolor sit amet',
              },
              {
                id: 6,
                message: 'lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec auctor, nisl eget ultrices aliquam, nunc nisl aliquet nunc, eget aliquam nisl',
              },
              {
                id: 7,
                message: 'lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec auctor,nisl eget ultrices aliquam, nunc nisl aliquet nunc, eget aliquam nisl ni loremlorem ipsum dolor sit amet, consectetur adipiscing elit. Donec auctor, nisl eget ultrices aliquam, nunc nisl aliquet nunc, eget aliquam nisl ni loremlorem ipsum dolor sit amet, consectetur adipiscing elit. Donec auctor, nisl eget ultrices aliquam',
              },
          ]"
      :min-item-size="54"
      :scroller-height="300"
      :scroller-width="500"
      :dynamic="true"
      style="
        margin: 20px 0;
        border: 1px solid red;"
    >
      <template #default="{ item }">
        <div style="
            padding: 0 12px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #eee;"
        >
          User {{ item.id}} <br />
          {{ item.message }}
        </div>
      </template>
    </dt-scroller>
</code-well-header>
<br>
<div class="language-html" data-highlighter="prismjs" data-ext="html"><pre v-pre><code class="language-html"><span class="line"><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>dt-scroller</span></span>
<span class="line"> <span class="token attr-name">:items</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>dynamicItems<span class="token punctuation">"</span></span></span>
<span class="line"> <span class="token attr-name">:min-item-size</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>54<span class="token punctuation">"</span></span></span>
<span class="line"> <span class="token attr-name">:scroller-height</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>300<span class="token punctuation">"</span></span></span>
<span class="line"> <span class="token attr-name">:scroller-width</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>500<span class="token punctuation">"</span></span></span>
<span class="line"> <span class="token attr-name">:dynamic</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>true<span class="token punctuation">"</span></span></span>
<span class="line"> <span class="token punctuation">></span></span></span>
<span class="line"> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>template</span> <span class="token attr-name">#default</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>{ item }<span class="token punctuation">"</span></span><span class="token punctuation">></span></span></span>
<span class="line">   <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>avatar<span class="token punctuation">"</span></span><span class="token punctuation">></span></span></span>
<span class="line">     {{ item.id }}</span>
<span class="line">     <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>img</span></span>
<span class="line">      <span class="token attr-name">:key</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>item.avatar<span class="token punctuation">"</span></span></span>
<span class="line">      <span class="token attr-name">:src</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>item.avatar<span class="token punctuation">"</span></span></span>
<span class="line">      <span class="token attr-name">alt</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>avatar<span class="token punctuation">"</span></span></span>
<span class="line">      <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>image<span class="token punctuation">"</span></span></span>
<span class="line">     <span class="token punctuation">></span></span></span>
<span class="line">  <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span></span>
<span class="line">  <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>text<span class="token punctuation">"</span></span><span class="token punctuation">></span></span></span>
<span class="line">     {{ item.message }}</span>
<span class="line">  <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span></span>
<span class="line"> <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>template</span><span class="token punctuation">></span></span></span>
<span class="line"><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>dt-scroller</span><span class="token punctuation">></span></span></span>
<span class="line"></span></code></pre>
</div><h2 id="vue-api" tabindex="-1" class="d-docsite--header-2">Vue API <a class="header-anchor d-link d-docsite--link d-link" href="#vue-api" aria-hidden="true">#</a></h2>
<component-vue-api component-name="scroller" /></div></template>


